var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"btn-twitter",attrs:{"loading":_vm.loading,"block":""},on:{"click":function($event){return _vm.initAssign()}}},[_vm._v(" "+_vm._s(_vm.driverName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }